import React, { useState } from 'react';
import entryGuideService from '../../services/entryGuideService';
import { loadEntryGuideDocumentData } from '../../services/entryGuideDocumentService';
import { downloadEntryGuidePdf } from '../../utils/generateEntryGuidePdf';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';
import EntryGuideDocumentProgressModal from './EntryGuideDocumentProgressModal';

const EntryGuidePdfButton = ({
  guideId,
  guideType,
  itemsCount = 0,
  guideCode = '',
  className = 'text-red-600 hover:text-red-800',
  title = 'Descargar PDF',
  onSuccess,
  onError,
  showLabel = false,
}) => {
  const { adjustmentMassiveItemThreshold } = useModuleSettings();
  const [loading, setLoading] = useState(false);
  const [progressOpen, setProgressOpen] = useState(false);
  const [progress, setProgress] = useState(null);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;

    setLoading(true);
    setProgressOpen(true);
    setProgress({
      phase: 'sync',
      status: 'processing',
      progress_percent: 5,
      message: 'Iniciando…',
    });

    try {
      const guideData = await loadEntryGuideDocumentData(guideId, {
        guideType,
        itemsCount,
        thresholdSettings: { adjustment_massive_item_threshold: adjustmentMassiveItemThreshold },
        onProgress: setProgress,
      });

      setProgress({
        phase: 'pdf',
        status: 'processing',
        progress_percent: 98,
        message: 'Generando PDF…',
      });

      await downloadEntryGuidePdf(guideData);
      onSuccess?.(guideData);
    } catch (error) {
      console.error('Error al generar PDF de guía:', error);
      onError?.(error?.message || 'Error al generar el PDF');
    } finally {
      setLoading(false);
      setProgressOpen(false);
      setProgress(null);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        disabled={loading}
        className={`inline-flex items-center gap-1 font-medium disabled:opacity-50 ${className}`}
        title={loading ? 'Generando PDF…' : title}
      >
        {loading ? (
          <span className="inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
        ) : (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
            />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 3v4a1 1 0 001 1h4M9 13h6M9 17h4" />
          </svg>
        )}
        {showLabel ? <span className="text-xs uppercase tracking-wide">PDF</span> : null}
      </button>

      <EntryGuideDocumentProgressModal
        isOpen={progressOpen}
        guideCode={guideCode}
        progress={progress}
      />
    </>
  );
};

export default EntryGuidePdfButton;
